export default __webpack_public_path__ + "static/media/ge7.2ba357b5.jpg";